import "./About.css"
import background from "./images/background.jpg"

const About = () => {
  return (
    <>
      <div className="about" id="about">
        <div className="mask">
          <img src={background} alt="Background" className="background-image" />
        </div>
        <div className="content">
          <h1>Hi! I Am Jatin Rawat</h1>
          <p>I am a MERN Stack and React Native Developer</p>
        </div>

      </div>


    </>

  )
}

export default About